(ns frontend.ux-overhaul.page-components.navigation.navbar
  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require
   [common.localization :as loc]
   [common.modules :as modules]
   [frontend.page-components.navbar-components.create-dropdown :as create-dropdown]
   [frontend.page-components.navbar-new-version.feedback-dropdown :as feedback-dropdown]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.page-components.navigation.account-dropdown-v2 :as account-dropdown-v2]
   [frontend.ux-overhaul.page-components.navigation.events :as events]
   [frontend.ux-overhaul.page-components.navigation.menu :as menu]
   [frontend.ux-overhaul.page-components.navigation.menu-items :as menu-items]
   [frontend.ux-overhaul.page-components.navigation.subs :as subs]
   [frontend.view.components.power-search :as power-search]
   [frontend.view.components.power-search.trigger.view :as os-power-search]
   [re-frame.core :as rf]
   [reagent.core :as r]

   ;; Experimental
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.select.select :as select]
   [ui.util :as uu]))

(defn experimental-ribbon-actions
  []
  (let [current-ribbon @(rf/subscribe [:frontend.test-ribbon.sub/current-ribbon])
        current-ribbon-id (:db/id current-ribbon)
        all-ribbons @(rf/subscribe [:frontend.test-ribbon.sub/all-ribbons])]
    [:div
     {:class "ml-2 mr-10 flex gap-2"}
     [:div
      {:class "relative w-80"}
      [select/view
       {:value     current-ribbon-id
        :on-change (fn [ribbon-id]
                     (rf/dispatch [:frontend.test-ribbon.event/open-ribbon ribbon-id]))
        :options   (->> all-ribbons
                        (mapv (fn [ribbon]
                                {:value (:db/id ribbon)
                                 :label (:ribbon/name ribbon)})))}]]
     [dropdown-menu/view
      {:items [{:label      (loc/tr :clone-this-ribbon)
                :icon-class "fal fa-clone"
                :on-click   #(rf/dispatch [:frontend.test-ribbon.event/open-clone-ribbon-modal])}
               {:label      (loc/tr :create-new-ribbon)
                :on-click   #(rf/dispatch [:frontend.test-ribbon.event/open-create-ribbon-modal])
                :icon-class "fal fa-plus"}
               {:label      (loc/tr :delete-ribbon)
                :icon-class "fal fa-trash-alt"
                :on-click   #(rf/dispatch [:frontend.test-ribbon.event/disable-ribbon current-ribbon-id])}]
       :props {:hide-arrow? true}
       :trigger-as-child
       [:button
        {:class "flex items-center gap-2 text-white whitespace-nowrap"}
        [:span (loc/tr :ribbon-actions)]
        [:i.fal.fa-angle-down]]}]]))

(defn logo
  []
  (let [current-module (session/current-module)
        route (get modules/module->route current-module)
        route (or route :oppos-grid)]
    [:a
     {:href     "/"
      :class    "block w-32 h-8 text-base-light-text"
      :on-click (without-default-action
                 (rf/dispatch [::events/navigate-to {:path route}]))}
     [:svg
      {:class   "block w-32 h-8"
       :xmlns   "http://www.w3.org/2000/svg"
       :fill    "none"
       :viewBox "0 0 160 40"}
      [:g
       {:clipPath "url(#a)"}
       [:path
        {:fill "currentColor"
         :d
         "M0 30.576V27.91L10.757 13.87H.697V9.232h17.446v2.666L7.385 25.832h11.128v4.746H0v-.002ZM120.327 19.92c0 7.287-4.859 11.134-10.972 11.134-6.113 0-10.972-3.847-10.972-11.134 0-7.288 4.859-11.135 10.972-11.135 6.113 0 10.972 3.847 10.972 11.134Zm-17.077 0c0 4.238 2.543 6.612 6.105 6.612 3.561 0 6.104-2.374 6.104-6.613 0-4.238-2.543-6.612-6.104-6.612-3.562 0-6.105 2.374-6.105 6.612ZM75.52 13.869h-4.317v-4.65h4.332v-2.06C75.535 2.838 78.543 0 83.16 0h3.674v4.511h-5.571a.861.861 0 0 0-.863.862v3.845h6.436v4.65H80.4v16.709h-4.877V13.869h-.002ZM90.527 0h4.866v30.577h-4.866V0ZM38.304 12.317V9.22h4.868V30.58h-4.868V27.3a.256.256 0 0 0-.487-.114c-1.218 2.433-3.168 4.043-6.86 4.043-6.326.043-11.006-3.856-11.006-11.351 0-7.496 4.897-11.222 11.134-11.178 3.48 0 5.505 1.687 6.726 3.75a.263.263 0 0 0 .491-.133h.002Zm.056 7.604c0-3.636-2.455-6.612-6.612-6.612s-6.613 2.976-6.613 6.612c0 3.637 2.693 6.613 6.613 6.613 3.92 0 6.613-2.976 6.613-6.613ZM51.852 12.317V9.22h-4.868v30.283h4.868V27.3a.256.256 0 0 1 .487-.114c1.218 2.433 3.168 4.043 6.86 4.043 6.326.043 11.006-3.856 11.006-11.351 0-7.496-4.897-11.222-11.134-11.178-3.48 0-5.505 1.687-6.726 3.75a.263.263 0 0 1-.491-.133h-.002Zm-.056 7.604c0-3.636 2.455-6.612 6.612-6.612s6.613 2.976 6.613 6.612c0 3.637-2.693 6.613-6.613 6.613-3.92 0-6.613-2.976-6.613-6.613ZM155.018 0l-8.237 27.107a.28.28 0 0 1-.537 0l-4.607-15.162L145.059.82V0h-4.982l-8.237 27.107a.282.282 0 0 1-.269.2.282.282 0 0 1-.269-.2l-5.431-17.874h-4.951v.808l6.319 20.538h8.66l2.87-9.329a.28.28 0 0 1 .537 0l2.87 9.329h8.66L160 .82V0h-4.982Z"}]]
      [:defs
       [:clipPath {:id "a"}
        [:path
         {:fill "currentColor"
          :d    "M0 0h160v39.503H0z"}]]]]]))

(defn key-hint
  [_props & children]
  (fn [_]
    [:div
     {:class "absolute bottom-1 text-xxs text-base-light-text-paler"}
     children]))

(defn view
  []
  (let [dropdown-state (r/atom {})]
    (fn []
      (let [modal-open? @(rf/subscribe [::subs/modal])]
        [:<>
         [:div
          {:class "px-4 relative flex gap-3 text-base-light-text
               border-b border-solid border-base-light-border-paler
               bg-base-light"}
          [:div {:class "flex items-center flex-1 gap-4"}
           [button/square-secondary-open
            {:tooltip  (if modal-open? (loc/tr :close-navigation-menu) (loc/tr :navigation-menu))
             :dom-id   "main-menu-icon"
             :on-click (fn []
                         ;;close old search full screen modal when opening full screen menu
                         (power-search/end-search! 0)
                         (deref power-search/state)
                         (rf/dispatch [::events/toggle-modal]))}
            (if modal-open?
              [:i.fal.fa-times.text-xl]
              [:i.fas.fa-grid.text-xl])
            (when (and modal-open? (not (session/is-mobile?)))
              [key-hint {:small? true}
               (loc/tr :shortcut-esc)])]
           [:div
            [logo]]
           (when (and (not (session/is-guest?))
                      (session/froppo-creation-flow-feature?))
             [:div
              {:class (uu/cm "ml-2")}
              [create-dropdown/dropdown dropdown-state "" true]])

           (when (session/show-experimental-ribbon-features?)
             [experimental-ribbon-actions])]

          [:div {:class "flex gap-3 justify-end items-center"}
           (when-not (or (session/is-guest?)
                         (session/froppo-creation-flow-feature?))
             [:div
              [create-dropdown/dropdown dropdown-state "" true]])
           (when-not (session/is-guest?)
             [os-power-search/trigger])
           (when (and (not (session/is-guest?))
                      (session/tasks-access?))
             [button/secondary-open
              {:class    "relative"
               :dom-id "navbar-tasks-button"
               :tooltip  (loc/tr :module/tasks)
               :on-click #(rf/dispatch [::events/navigate-to {:path :tasks-grid}])}
              [:i.fas.fa-tasks.text-xl]
              [menu-items/bullet true]])
           [:div
            [feedback-dropdown/dropdown dropdown-state]]
           [:span
            [account-dropdown-v2/dropdown dropdown-state (session/is-guest?) false]]]]
         (when modal-open? [menu/view])]))))
